import { DangerouslySetInnerHTML } from '@infl-ts/ui-advocate-components';
import { BlockWidthWrapper } from '@infl-ts/util-block-width-context';
import { Box, Paper } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";

var TermsAndConditionsBlock = function TermsAndConditionsBlock(_ref) {
  var body = _ref.block.body;
  return /*#__PURE__*/_jsx(BlockWidthWrapper, {
    "data-element": "BlockWidthWrapper",
    "data-component": "TermsAndConditionsBlock",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Paper, {
      sx: {
        m: 2
      },
      elevation: 0,
      "data-element": "Paper",
      "data-component": "TermsAndConditionsBlock",
      "data-source-file": "index.tsx",
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          minHeight: 100,
          width: 1,
          p: 2
        },
        "data-element": "Box",
        "data-component": "TermsAndConditionsBlock",
        "data-source-file": "index.tsx",
        children: body ? /*#__PURE__*/_jsx(DangerouslySetInnerHTML, {
          body: body
        }) : null
      })
    })
  });
};

export default TermsAndConditionsBlock;